import classNames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'
import { useMedia } from 'react-use'

import MorePropTypes from '../../common/MorePropTypes'
import { mediaQueries } from '../../constants/media'
import Icon from '../Icon/Icon'
import Text from '../Text/Text'
import s from './Callout.module.scss'

export default function Callout({ className, title, body, summary, type = 'success' }) {
  const smUp = useMedia(mediaQueries.smUp, true)

  const iconType = {
    success: 'check-in-circle',
    error: 'exclamation-triangle-fill',
    notice: 'exclamation-circle-fill'
  }[type]

  return (
    <div className={classNames(s.callout, className, { [s.error]: type === 'error' })}>
      <Icon size={smUp ? 'xl' : 'l'} type={iconType} />
      <Text className={s.content}>
        <div>
          {title && (
            <div className={s.header}>
              <span>{title}</span>
            </div>
          )}
          <div className={s.body}>{body}</div>
        </div>
        {summary && (
          <>
            <div className={s.divider}>
              <hr />
              <div className={s.vertical} />
            </div>
            <div className={s.summary}>{summary}</div>
          </>
        )}
      </Text>
    </div>
  )
}

Callout.propTypes = {
  body: PropTypes.node,
  className: MorePropTypes.className,
  summary: PropTypes.node,
  title: PropTypes.string,
  type: PropTypes.string
}
